import { render, staticRenderFns } from "./admin_articles_by_key.vue?vue&type=template&id=bd8178ae&scoped=true"
import script from "./admin_articles_by_key.vue?vue&type=script&lang=js"
export * from "./admin_articles_by_key.vue?vue&type=script&lang=js"
import style0 from "./admin_articles_by_key.vue?vue&type=style&index=0&id=bd8178ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8178ae",
  null
  
)

export default component.exports